// extracted by mini-css-extract-plugin
module.exports = {"root":"InlineError_root__2X-ra","icon":"InlineError_icon__2MhdM"};